export default __webpack_public_path__ + "static/media/single-staggered-border-none.872329b9.svg";